__webpack_require__.p = "/bank_modern_app/";